module.exports = __webpack_public_path__ + "img/expostyle_9019_mauve.6dd9779e.jpg";